// extracted by mini-css-extract-plugin
export default {"Button":"IPButton_Button__2JyS3","Rounded":"IPButton_Rounded__wb-dO"};